declare global {
  interface Window {
    [Recaptcha.onLoad]: () => void
    grecaptcha: {
      execute: (widgetId: number) => void
      getResponse: (widgetId: number) => string
      render: (el: HTMLElement, options: RenderOptions) => number
      reset: (widgetId: number) => void
    }
  }
}

type RenderOptions = {
  sitekey: string
  callback: (token: string) => void
  "expired-callback": () => void
  size: string
}

type Ports = {
  tokenReceived: PortToElm<string>
  expired: PortToElm<null>
  execute: PortFromElm<string>
}

export default class Recaptcha {
  static readonly onLoad = "recaptchaOnLoad"
  private widgetId = -1

  constructor(containerId: string, siteKey: string, elmApp: ElmApp<Ports>) {
    const container =
      document.getElementById(containerId) ||
      document.body.appendChild(Object.assign(document.createElement("div"), { id: containerId }))
    const recaptchaOnLoad = window[Recaptcha.onLoad]

    window[Recaptcha.onLoad] = (): void => {
      if (recaptchaOnLoad) recaptchaOnLoad()

      this.widgetId = window.grecaptcha.render(container, {
        sitekey: siteKey,
        callback: elmApp.ports.tokenReceived.send,
        "expired-callback": (): void => elmApp.ports.expired.send(null),
        size: "invisible"
      })
    }

    elmApp.ports.execute.subscribe(() => this.execute(elmApp.ports.tokenReceived.send))
    this.appendApi()
  }

  execute(callback: (token: string) => void): void {
    const token = window.grecaptcha.getResponse(this.widgetId)

    if (token) {
      callback(token)
    } else {
      window.grecaptcha.reset(this.widgetId)
      window.grecaptcha.execute(this.widgetId)
    }
  }

  private appendApi(): void {
    const RECAPTCHA_SCRIPT_ID = "js-grecaptcha"
    const api = document.getElementById(RECAPTCHA_SCRIPT_ID)

    if (!api) {
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.src = `https://www.google.com/recaptcha/api.js?onload=${Recaptcha.onLoad}&render=explicit`
      script.defer = true
      script.id = RECAPTCHA_SCRIPT_ID
      document.head.appendChild(script)
    }
  }
}
